import { request, METHOD } from '@/utils/request.js'



// 添加准考证
export function insertIntoFaceData(data) {
    return request(
      '/h5Mfitness/teacher/insertIntoFaceData',
      METHOD.POST,
      data
    )
  }
  // 检验人脸
export function checkFace(data) {
    return request(
      '/h5Mfitness/com/checkFace',
      METHOD.POST,
      data
    )
  }
  // 作废准考证
  export function updateFaceStatus(data) {
    return request(
      '/h5Mfitness/parent/updateFaceStatus',
      METHOD.POST,
      data
    )
  }
  

  